const normalizePhone = (phone) => {
	let matched = phone.match(/\d+/g);
	if(matched && matched.length) {
		let cleanPhone = matched.join('');
		if(cleanPhone.startsWith('9')){
			cleanPhone = '+' + cleanPhone;
		}
		return cleanPhone;
	}
	else {
		return '';
	}
}

export default normalizePhone